import { Typography } from "@material-tailwind/react";
import { Tooltip } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { utils } from "ethers";
import moment from "moment";
import Link from "next/link";
import { useState } from "react";
import { MdClose, MdOpenInNew } from "react-icons/md";
import { useAccount } from "wagmi";
import {
  getNftImageFromCDN,
  helperConstants,
} from "../../helpers/helperConstants";

export const LendsTable = ({
  rows,
  totalPages,
  totalCount,
  currentPage,
  setCurrentPage,
  loading,
  setSearchText,
  searchText,
  onSearchClick,
  pageSize = 10,
}: {
  rows: any[];
  totalPages: number;
  totalCount: number;
  currentPage: number;
  setCurrentPage: any;
  loading: boolean;
  setSearchText: any;
  searchText: string;
  onSearchClick: any;
  pageSize?: number;
}) => {
  const { address, isConnected } = useAccount();

  const columns: GridColDef[] = [
    {
      field: "image",
      headerName: "Asset",
      flex: 1.5,
      minWidth: 150,
      disableColumnMenu: true,
      disableReorder: true,
      filterable: false,
      sortable: false,
      renderCell: (params: any) => {
        const offer = params.row;
        const collection = offer.collection;
        const item = offer.item;
        const image = getNftImageFromCDN({
          imageFtpPath: item.imageFtpPath,
          isDNFT: collection.isDNFT,
          tokenId: item.itemId,
          collectionInfo: collection,
          metadata: item.metadata,
          imagesize: "thumbnail",
        });
        let metadata = item.metadata;
        metadata =
          typeof metadata === "string" ? JSON.parse(metadata) : metadata;
        return (
          <div className="flex items-center">
            <img src={image} className="w-10 h-10 rounded-full" />
            <div className="ml-2">
              <p className="text-sm font-bold">{item.name || metadata?.name}</p>
            </div>
          </div>
        );
      },
    },
    {
      field: "borrower",
      headerName: "Owner",
      flex: 1,
      minWidth: 100,
      disableColumnMenu: true,
      disableReorder: true,
      filterable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div>
            <div className="flex items-center space-x-2">
              <Tooltip title={row?.issuer}>
                <div className="text-sm font-bold truncate">
                  {row?.issuer &&
                    row?.issuer.slice(0, 6) + "..." + row?.issuer.slice(-4)}
                </div>
              </Tooltip>
            </div>
          </div>
        );
      },
    },
    // {
    //   field: "duration",
    //   headerName: "Duration",
    //   flex: 0.8,
    //   sortable: false,
    //   minWidth: 100,
    //   renderCell: (props) => {
    //     // console.log(props)
    //     return (
    //       <div>
    //         {props?.value
    //           ? `${moment().add(props.value, "seconds").fromNow(true)}`
    //           : ""}
    //       </div>
    //     );
    //   },
    // },
    // {
    //   field: "expiration",
    //   headerName: "Expiration",
    //   sortable: false,
    //   flex: 0.8,
    //   minWidth: 100,
    //   renderCell: ({ value, row }) => {
    //     return (
    //       <div>{value && moment().add(value, "seconds").fromNow(true)}</div>
    //     );
    //   },
    // },
    {
      field: "terms",
      headerName: "Terms",
      flex: 1.4,
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      disableColumnMenu: true,
      disableReorder: true,
      filterable: false,
      sortable: false,
      renderCell(params) {
        return (
          <Typography variant="small">
            {params?.row?.borrowAmount &&
              utils.formatEther(params?.row?.borrowAmount)}{" "}
            {params?.row?.paymentTokenName} /{" "}
            {params?.row?.duration &&
              moment().add(params?.row?.duration, "seconds").fromNow(true)}
          </Typography>
        );
      },
    },
    {
      field: "actions",
      headerName: "",
      // flex: 1,
      minWidth: 150,
      disableColumnMenu: true,
      disableReorder: true,
      filterable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const isOwner =
          address && row?.itemowner
            ? row.itemowner.length > 0 && address === row.itemowner[0].owner
            : row?.item?.itemowner.length > 0 &&
              address === row?.item?.itemowner[0].owner;

        return (
          <div className="grid grid-cols-10 gap-2 items-center">
            <div className="col-span-7">
              <Link href={`/lend/${row.nftAddress}/${row.colleteralTokenID}`}>
                <a
                  className="bg-accent w-full inline-flex justify-center shadow-accent-volume hover:bg-accent-dark rounded-full py-2 px-1 text-center font-semibold text-white transition-all"
                  href={`/lend/${row.nftAddress}/${row.colleteralTokenID}`}
                >
                  {isOwner ? "View" : "Make Offer"}
                </a>
              </Link>
            </div>
            <div className="col-span-2">
              <a
                href={`${helperConstants.helpers.marketplace_url}/item/${row?.item?.chain}/${row?.item?.collectionAddress}/${row?.item?.itemId}`}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center w-8"
              >
                <MdOpenInNew size={18} className="text-accent-light" />
              </a>
            </div>
          </div>
        );
      },
    },
  ];

  return (
    <DataGrid
      rows={rows}
      loading={loading}
      columns={columns}
      pageSize={pageSize}
      autoHeight
      rowCount={totalCount}
      page={currentPage}
      rowsPerPageOptions={[pageSize]}
      disableSelectionOnClick
      paginationMode="server"
      rowHeight={80}
      components={{
        Toolbar() {
          const [search, setSearch] = useState(searchText);

          return (
            <div className="relative m-5" onSubmit={onSearchClick}>
              <input
                type="search"
                className="text-jacarta-700 placeholder-jacarta-500 focus:ring-accent border-jacarta-100 w-full rounded-xl border py-[0.6875rem] px-4  dark:border-transparent dark:bg-white/[.15] dark:text-white dark:placeholder-white"
                placeholder="Search"
                name="search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              {search !== "" && (
                <div className="absolute right-10 top-0 flex h-full w-12 items-center">
                  <button
                    onClick={() => {
                      setSearch("");
                      setSearchText("");
                    }}
                    className="text-white transition-all"
                  >
                    <MdClose size={24} />
                  </button>
                </div>
              )}
              <button
                onClick={() => {
                  setSearchText(search);
                }}
                className="absolute right-0 top-0 flex h-full w-12 items-center justify-center rounded-xl        bg-jacarta-500 shadow-jacarta-500 hover:bg-accent-dark text-center font-semibold text-white transition-all"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width={24}
                  height={24}
                  className=" h-4 w-4 fill-white"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M18.031 16.617l4.283 4.282-1.415 1.415-4.282-4.283A8.96 8.96 0 0 1 11 20c-4.968 0-9-4.032-9-9s4.032-9 9-9 9 4.032 9 9a8.96 8.96 0 0 1-1.969 5.617zm-2.006-.742A6.977 6.977 0 0 0 18 11c0-3.868-3.133-7-7-7-3.868 0-7 3.132-7 7 0 3.867 3.132 7 7 7a6.977 6.977 0 0 0 4.875-1.975l.15-.15z" />
                </svg>
              </button>
            </div>
          );
        },
      }}
      componentsProps={{
        noRowsOverlay: {
          className: "dark:bg-jacarta-700 dark:text-white",
        },
        loadingOverlay: {
          className: "dark:bg-jacarta-700 dark:text-white",
        },
      }}
      onPageChange={(e, details) => {
        setCurrentPage(e);
        window.location.href = "#";
      }}
      classes={{
        cell: "dark:text-jacarta-300 text-black ",
        columnHeaderTitle: "dark:text-white text-jacarta-900",
        checkboxInput: "dark:text-jacarta-300 text-black",
        root: "dark:bg-jacarta-700 dark:border-jacarta-600 border-jacarta-100 rounded-2lg border bg-white",
        footerCell: "dark:!text-jacarta-300 !text-black",
        panelFooter: "dark:!text-jacarta-300 !text-black",
        toolbarContainer: "dark:!text-jacarta-300 !text-black",
        toolbarFilterList: "dark:!text-jacarta-300 !text-black",
        footerContainer: "dark:!text-jacarta-300 !text-black",
        filterForm: "dark:!text-jacarta-300 !text-black",
        menuIconButton: "dark:!text-jacarta-300 !text-black",
        sortIcon: "dark:!text-jacarta-300 !text-black",
      }}
      sx={{
        ".MuiToolbar-root": {
          color: "gray",
        },
      }}
    />
  );
};
